(function (window) {
  'use strict';

  // Freshine Swatch Order
  // 统一维护小样相关 ORDER 按钮行为。
  //
  // 背景：
  // - 小样页、商详页旧抽屉、 小样抽屉曾各自维护跳转逻辑。
  // - 旧逻辑会模拟点击 checkout / cart 图标；移动端可能命中隐藏的桌面图标，
  //   导致按钮点击后没有视觉反馈。
  // - 当前业务期望是直接进入购物车页面，因此统一收敛为 goToCart()。
  //
  // 使用方式：
  //   window.FreshineSwatchOrder.configure({ cartUrl: '/cart' });
  //   window.FreshineSwatchOrder.goToCart();
  var previousApi = window.FreshineSwatchOrder || {};
  var state = {
    cartUrl: previousApi.cartUrl || '/cart',
  };

  function configure(options) {
    if (!options) return;

    if (typeof options.cartUrl === 'string' && options.cartUrl !== '') {
      state.cartUrl = options.cartUrl;
    }
  }

  function goToCart() {
    window.location.href = state.cartUrl || '/cart';
  }

  window.FreshineSwatchOrder = {
    configure: configure,
    goToCart: goToCart,
    get cartUrl() {
      return state.cartUrl;
    },
  };
})(window);
